import chartComponentUrl from './chartComponent.html';

export default {
  bindings: {
    labels: '<',
    data: '<',
    colors: '<',
    groupLabels: '<',
    colwidth: '<?',
    compact: '@',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './chartComponentCtrl')).default,
  templateUrl: chartComponentUrl,
};
